import { Subject, type Observable } from 'rxjs'

export interface IAppLifecycleService {
  isOnAfterFirstRenderEmitted: boolean
  onInit$: Observable<void>
  onAfterFirstRender$: Observable<void>

  emitOnInit(): void
  emitOnAfterFirstRender(): void

  disposeContainer(): void
}

export class AppLifecycleService implements IAppLifecycleService {
  public isOnAfterFirstRenderEmitted: boolean = false
  public onInit$: Observable<void>
  public onAfterFirstRender$: Observable<void>
  private onInitSubject: Subject<void>
  private onAfterFirstRenderSubject: Subject<void>

  constructor() {
    this.onInitSubject = new Subject<void>()
    this.onInit$ = this.onInitSubject.asObservable()
    this.onAfterFirstRenderSubject = new Subject<void>()
    this.onAfterFirstRender$ = this.onAfterFirstRenderSubject.asObservable()
  }

  public emitOnInit(): void {
    this.onInitSubject.next()
  }

  public emitOnAfterFirstRender(): void {
    this.onAfterFirstRenderSubject.next()

    const count = Number(localStorage.getItem('initCount') || 0)
    localStorage.setItem('initCount', String(count + 1))
    window.addEventListener('beforeunload', this.disposeContainer.bind(this))
    this.isOnAfterFirstRenderEmitted = true
  }

  public disposeContainer(): void {
    // const disposables = this.container!.getAll<IDisposable>('IDisposable')
    // disposables.forEach((d) => d.dispose())
    // console.log('AppLifecycle service dispose')
    // const count = Number(localStorage.getItem('disposeCount') || 0)
    // localStorage.setItem('disposeCount', String(count + 1))
  }
}

// export class AppLifecycleServiceMock implements IAppLifecycleService {
//   public isInit: boolean
//   public onAfterFirstRender: Observable<void>
//   public init(container: IContainer<DiId>): void {
//     throw new Error('Method not implemented.')
//   }
//   public disposeContainer(): void {
//     throw new Error('Method not implemented.')
//   }
// }
